import dayjs from 'dayjs'
import { DurationUnits } from '@/shared/constants/date/DurationUnits'

export function add23Hours59MinutesToDate(date) {
  return dayjs(date)
    .add(23, DurationUnits.HOUR)
    .add(59, DurationUnits.MINUTE)
    .add(59, DurationUnits.SECOND)
}
